import { distanceStringMeterToKm, secondsToTimestamp } from '@/commons/utils';
import { basicInfoAtom, changeCarListAtom, selectedCarListAtom, shippingListAtom } from '@/commons/constants';
import { Card, Divider } from '@mui/material';
import { useAtomValue } from 'jotai';
import styled from 'styled-components';
import InfoCard from '../InfoCard';
import * as _ from 'lodash';
import { useEffect, useState } from 'react';

const MainWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

const ContentBox = styled(Card)`
  width: 100%;
  height: 100%;
  background : #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export default function BasicInfo() {
  const basicInfo = useAtomValue(basicInfoAtom);

  const shippingList = useAtomValue(shippingListAtom);
  const selectedCarList = useAtomValue(selectedCarListAtom);

  const changeCarList = useAtomValue(changeCarListAtom);

  const [selectedInfo, setSelectedInfo] = useState<{ distance: number; time: number }>({ distance: 0, time: 0 });

  useEffect(() => {
    if (basicInfo) {
      if (shippingList && selectedCarList) {
        const tempList = selectedCarList.map((item: number) => {
          return _.find(shippingList, ['car.car_seq', item]);
        });
        const retVal: { distance: number; time: number } = {
          distance: _.sumBy(tempList, 'distance'),
          time: _.sumBy(tempList, 'time'),
        };
        setSelectedInfo(retVal);
      } else {
        setSelectedInfo({ distance: basicInfo.totalDistance, time: basicInfo.totalTime });
      }
    }
  }, [basicInfo, shippingList, selectedCarList]);

  return (
    <MainWrap>
      <ContentBox>
        <InfoCard
          title="총 거리"
          desc={!changeCarList || changeCarList.length === 0 ? distanceStringMeterToKm(selectedInfo.distance) : '--'}
        />
        <Divider orientation="vertical" variant="middle" flexItem />
        <InfoCard
          title="총 시간"
          desc={!changeCarList || changeCarList.length === 0 ? secondsToTimestamp(selectedInfo.time) : '--'}
        />
      </ContentBox>
    </MainWrap>
  );
}
